var _a;
import { getCurrencyByKey } from "./currencies";
var _KRW_KEY = "KRW";
var KRW_SUFFIXES = ["만", "억", "조"];
export var SUFFIXES = (_a = {
        default: ["K", "M", "B", "T"]
    },
    _a[getCurrencyByKey(_KRW_KEY)] = KRW_SUFFIXES,
    _a[_KRW_KEY] = KRW_SUFFIXES,
    _a);
export var getInputValueByCurrency = function (currency, value) {
    return currency && SUFFIXES[currency] ? 1e4 : value;
};
export var buildFormatProperties = function (minFractionDigits, maxFractionDigits, isCeil, limitIncludeFraction, limitValue, startValue, limit, currency, additionalLimitations) {
    if (additionalLimitations === void 0) { additionalLimitations = {}; }
    var suffixes = SUFFIXES[currency] || SUFFIXES.default;
    var calculatedStartValue = getInputValueByCurrency(currency, startValue);
    return {
        minFractionDigits: minFractionDigits,
        maxFractionDigits: maxFractionDigits,
        isCeil: isCeil,
        additionalLimitations: additionalLimitations,
        limit: limit,
        inputValues: suffixes.map(function (suffix, index) { return ({
            inputValue: Math.pow(calculatedStartValue, index + 1),
            limitIncludeFraction: limitIncludeFraction,
            limitValue: limitValue,
            divideBy: Math.pow(calculatedStartValue, index + 1),
            suffix: suffix,
        }); }),
    };
};
